let lastScrollY = window.scrollY;
document.addEventListener("scroll", () => {
  var productInfo = document.querySelector('product-info');
  var signature = document.querySelector('.signatures-animation');
  var scrollEnterComparison = false;
  if (document.querySelector('comparison-table')) {
    scrollEnterComparison = document.querySelector('comparison-table').getBoundingClientRect().bottom + 800 > window.innerHeight && document.querySelector('comparison-table').getBoundingClientRect().top < 0;
  }
  if (productInfo && signature) {
    var scrollEnter = signature.getBoundingClientRect().bottom > 0 && productInfo.getBoundingClientRect().top < 0;
  }
  if (scrollEnter || window.scrollY == 0 || scrollEnterComparison) {
    document.querySelector("header").style.opacity = 0;
    if (document.querySelector(".movo_announcement_bar_wrapper")) {
      document.body.classList.add('product-audi-hide-announcement')
    }
    // document.querySelector('.productdetail-topbar').style.display = "none"
  } else {
    document.querySelector('header').removeAttribute('style')
    if (document.querySelector(".movo_announcement_bar_wrapper")) {
      document.body.classList.remove('product-audi-hide-announcement')
    }
    // document.querySelector('.productdetail-topbar').style.display = "block"
  }
  if(window.innerWidth < 990){
    var rect = document.querySelector('signatures-animation').getBoundingClientRect();
  }else{
    var rect = document.querySelector('.product-form__actions-atc .add-to-cart-btn').getBoundingClientRect();
  }
  const scrollingDown = window.scrollY > lastScrollY;

  // Điều kiện hiển thị:
  // 1. Scroll xuống
  // 2. Nút chính nằm phía trên viewport (rect.bottom < 0)
  if (scrollingDown && rect.bottom < 0) {
    const compStyles = window.getComputedStyle(document.querySelector('header'));
    if(window.innerWidth < 990)
    if(compStyles.getPropertyValue("opacity") == '1'){
      document.querySelector('.productdetail-topbar').style.top = document.querySelector('.sticky-header').offsetHeight - 8 + document.querySelector('.movo_announcement_bar_wrapper').offsetHeight + 'px'
    }else{
      document.querySelector('.productdetail-topbar').style.top = '0'
    }
    document.querySelector('.productdetail-topbar').style.display = 'block';
  } else {
    document.querySelector('.productdetail-topbar').removeAttribute('style')
  }

  lastScrollY = window.scrollY;
})
if(document.querySelector('.custom-okeReviews-reviewsTab')){
  document.querySelector('.custom-okeReviews-reviewsTab').addEventListener('click',() =>{
    document.querySelector('.product-info-review .okeReviews-reviewsSummary').click()
  })
}
class ProductInfo extends HTMLElement {
  constructor() {
    super();
    this.media = this.querySelector(".product__media");
    this.thumbs = this.querySelector(".product__thumbs");
    this.mediaReviews = this.querySelector(".media-reviews");
    this.mediaQuotes = this.querySelector(".media-quotes");
    this.pendingRequestUrl;
    this.productUrl = this.dataset.url;
    this.variantSelected;
    this.plusBtn = this.querySelector(".qty-plus");
    this.minusBtn = this.querySelector(".qty-minus");
    this.atcBtn = this.querySelector('.add-to-cart-btn')
    this.qtySelector = this.querySelector(".quantity-selector");
    this.form = this.querySelector(".shopify-product-form");
    this.productId = this.dataset.id;
    this.ratingContainer = this.querySelectorAll('.rating-container');
    this.buyServices = this.querySelectorAll('.service-item');
    this.cartBarBtn = this.querySelector('.productdetail-topbar .topbar-inner .topbar-info .cta-addtocard');
  }
  connectedCallback() {
    if(window.innerWidth < 990){
      // document.querySelector('header').removeAttribute('style')
      // document.body.classList.remove('product-audi-hide-announcement')
      // document.querySelector('header').classList.remove('transparent')
      // document.querySelector('.product-section').style.marginTop = document.querySelector('.sticky-header').offsetHeight - 8 + document.querySelector('.movo_announcement_bar_wrapper').offsetHeight + 'px'
    }
    this.variantSelected = JSON.parse(
      this.querySelector(".product-options-selectbox [data-selected-variant]").innerHTML
    );
    this.swiperMedia();
    this.mediaReviewsSwiper = new Swiper(this.mediaReviews, {
      slidesPerView: "auto",
      spaceBetween: 16
    });
    this.mediaQuotesSwiper = new Swiper(this.mediaQuotes, {
      slidesPerView: "auto",
      spaceBetween: 16
    });
    // if(window.innerWidth >= 768){
    //   this.media.querySelectorAll('.image-zoom').forEach(img => {
    //     this.imageZoom(img.querySelector('img'), document.querySelector('.img-zoom-result'),{ maxBG: 1500, lensSize: 200 });
    //   })
    // }
    this.querySelectorAll('.media-quote').forEach(award => {
      award.addEventListener('click', () => {
        window.open(award.dataset.link, '_blank');
      })
    })
    // this.updateMedia();
    this.addEventListener("change:variant", (e) => {
      this.renderProductInfo({
        requestUrl: e.detail.requestUrl,
        productUrl: e.detail.productUrl,
        targetId: e.detail.targetId,
        callback: this.handleUpdateProductInfo(this.productUrl),
      });
    });
    this.plusBtn.addEventListener("click", this.updateQuantity.bind(this));
    this.minusBtn.addEventListener("click", this.updateQuantity.bind(this));
    this.form.addEventListener("submit", this.formSubmit.bind(this));
    this.ratingContainer.forEach(x => {
      x.addEventListener('click', () => {
        this.show()
      })
    })
    document.querySelectorAll('.js-reviews-close').forEach(btn => {
      btn.addEventListener('click', () => {
        this.hide()
      })
    })
    this.buyServices.forEach(service => {
      if (service.hasAttribute('data-href')) {
        service.addEventListener('click', () => {
          window.location.href = service.dataset.href;
        })
      }
      if (service.hasAttribute('data-popup')) {
        service.addEventListener('click', () => {
          document.querySelector('.' + service.dataset.popup).classList.remove('-in-active')
        })
      }
    })
    this.cartBarBtn.addEventListener('click',(e) => {
      e.preventDefault();
      this.form.dispatchEvent(new Event('submit'))
    })
  }

  imageZoom(img, result,{maxBG=1500, lensSize=120} = {}) {
    var lens, cx, cy;

    /* Tạo lens */
    lens = document.createElement("DIV");
    lens.setAttribute("class", "img-zoom-lens");
    img.parentElement.appendChild(lens);

    let effCx = 1, effCy = 1;

    /* Tính tỷ lệ phóng */
    cx = window.innerWidth * 0.35 / lens.offsetWidth;
    cy = window.innerWidth * 0.35 / lens.offsetHeight;
    let zoomWidth = img.width * cx;
    let zoomHeight = img.height * cy;


    result.style.backgroundImage = "url('" + img.dataset.zoomSrc + "')";
    result.style.backgroundSize = zoomWidth + "px " + zoomHeight + "px";

    /* Event */
    recalc();
    window.addEventListener("resize", recalc);
    lens.addEventListener("mousemove", moveLens);
    img.addEventListener("mousemove", moveLens);
    lens.addEventListener("touchmove", moveLens);
    img.addEventListener("touchmove", moveLens);

    function moveLens(e) {
      e.preventDefault();
      const pos = getCursorPos(e);
      let x = pos.x - lens.offsetWidth  / 2;
      let y = pos.y - lens.offsetHeight / 2;
      let mouseX = pos.x;
      let mouseY = pos.y;

      // giới hạn lens trong ảnh
      x = Math.max(0, Math.min(x, img.clientWidth  - lens.offsetWidth));
      y = Math.max(0, Math.min(y, img.clientHeight - lens.offsetHeight));

      lens.style.left = x + "px";
      lens.style.top  = y + "px";
      if(mouseX <= 5 || mouseY <= 5 || mouseX >= img.clientWidth -5 || mouseY >= img.clientHeight - 5){
        lens.style.opacity = 0;
        result.classList.add('hide')
      }else{
        lens.style.opacity = 1;
        result.classList.remove('hide')
      }

      // dùng hệ số phóng THỰC TẾ
      result.style.backgroundImage = `url('${img.dataset.zoomSrc}')`;
      result.style.backgroundPosition = `-${x * effCx}px -${y * effCy}px`;
    }

    function recalc() {
      // hệ số phóng cơ sở (nếu không giới hạn)
      const cxBase = window.innerWidth * 0.35  / lens.offsetWidth;
      const cyBase = window.innerWidth * 0.35 / lens.offsetHeight;

      // background-size mặc định
      const bgW0 = img.clientWidth  * cxBase;
      const bgH0 = img.clientHeight * cyBase;

      // giới hạn về maxBG (giữ đúng tỉ lệ)
      const scale = Math.min(1, maxBG / Math.max(bgW0, bgH0));
      const bgW = bgW0 * scale;
      const bgH = bgH0 * scale;

      // hệ số phóng THỰC TẾ dùng cho background-position
      effCx = bgW / img.clientWidth;
      effCy = bgH / img.clientHeight;

      result.style.backgroundImage = `url('${img.dataset.zoomSrc}')`;
      result.style.backgroundSize  = `${bgW}px ${bgH}px`;
    }

    function getCursorPos(e){
      e = e || window.event;
      const rect = img.getBoundingClientRect();
      const pageX = e.touches ? e.touches[0].pageX : e.pageX;
      const pageY = e.touches ? e.touches[0].pageY : e.pageY;
      return {
        x: pageX - rect.left - window.pageXOffset,
        y: pageY - rect.top  - window.pageYOffset
      };
    }
  }

  hide() {
    var tl = gsap.timeline({
      onComplete: function () {
        document.body.setAttribute('popip', 'hide')
      }
    });

    tl.to('.reviews-inner', { duration: .2, opacity: 0, y: 500, ease: "none" })
      .set('.popup-reviews', { display: 'none' })

  }
  show() {
    document.body.setAttribute('popip', 'show')

    var tl = gsap.timeline();

    tl.set('.reviews-inner', { opacity: 0, y: 500 })
      .set('.popup-reviews', { display: 'block', opacity: 0, y: 500 })
      .to('.popup-reviews', { duration: .3, opacity: 1, y: 0 })
      .to('.popup-reviews' + ' .reviews-inner', { duration: .2, opacity: 1, y: 0, ease: "none" })
  }
  renderProductInfo({ requestUrl, targetId, callback }) {
    fetch(requestUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        callback(html);
      })
      .then(() => {
        // set focus to last clicked option value
        document.querySelector(`#${targetId}`)?.focus();
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.log("Fetch aborted by user");
        } else {
          console.error(error);
        }
      });
  }
  renderBuildComfortSection({ productUrl, variantId, targetId, callback }) {
    fetch(`${productUrl}?variant=${variantId}&section_id=${targetId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        callback(html);
      })
      .then(() => {
        // set focus to last clicked option value
        // document.querySelector(`#${targetId}`)?.focus();
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.log("Fetch aborted by user");
        } else {
          console.error(error);
        }
      });
  }
  renderSignatureSection({ productUrl, variantId, targetId, callback }) {
    fetch(`${productUrl}?variant=${variantId}&section_id=${targetId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        callback(html);
      })
      .then(() => {
        // set focus to last clicked option value
        // document.querySelector(`#${targetId}`)?.focus();
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.log("Fetch aborted by user");
        } else {
          console.error(error);
        }
      });
  }
  handleUpdateBuildComfortSection(productUrl) {
    return (html) => {
      if (html.querySelector('.contruction-materials')) {
        document.querySelector('.contruction-materials').innerHTML =
          html.querySelector('.contruction-materials').innerHTML;
      }
      if (html.querySelector('.posture-perfect-ergonomics')) {
        document.querySelector('.posture-perfect-ergonomics').innerHTML =
          html.querySelector('.posture-perfect-ergonomics').innerHTML;
      }
    }
  }
  handleUpdateSignatureSection(productUrl) {
    return (html) => {
      if (html.querySelector('.shopify-signatures-animation-section')) {
        document.querySelector('.shopify-signatures-animation-section').innerHTML =
          html.querySelector('.shopify-signatures-animation-section').innerHTML;
      }
    }
  }
  handleUpdateProductInfo(productUrl) {
    return (html) => {
      this.variantSelected = this.getSelectedVariant(html);

      // this.pickupAvailability?.update(variant);
      this.updateOptionValues(html);
      this.updateURL(productUrl, this.variantSelected?.id);
      this.renderBuildComfortSection({
        productUrl,
        variantId: this.variantSelected?.id,
        targetId: document.querySelector('.build-comfort-section').dataset.id,
        callback: this.handleUpdateBuildComfortSection(this.productUrl),
      });
      this.renderSignatureSection({
        productUrl,
        variantId: this.variantSelected?.id,
        targetId: document.querySelector('.shopify-signatures-animation-section').dataset.id,
        callback: this.handleUpdateSignatureSection(this.productUrl),
      });
      this.updateSourceFromDestination(
        ".product-info-main .product-price",
        html
      );
      this.updateSourceFromDestination(
        ".product-form-atc__header .product-price",
        html
      );
      this.updateSourceFromDestination(
        ".product-form__actions-atc",
        html
      );
      this.updateSourceFromDestination(
        ".product__media-wrapper",
        html
      );
      this.updateSourceFromDestination(
        ".topbar-inner .topbar-img",
        html
      );
      this.updateSourceFromDestination(
        ".topbar-inner .topbar-info .topbar-info__title .title",
        html
      );
      this.updateSourceFromDestination(
        ".product-option-title",
        html
      );
      this.updateSourceFromDestination(
        ".topbar-inner .topbar-info .topbar-info__price",
        html
      );
      this.swiperMedia()
      // this.updateMedia();
      this.updateVariantInputs(this.variantSelected?.id);

      // if (!variant) {
      //   this.setUnavailable();
      //   return;
      // }

      // this.updateMedia(html, variant?.featured_media?.id);

      // const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
      //   const source = html.getElementById(`${id}-${this.sectionId}`);
      //   const destination = this.querySelector(`#${id}-${this.dataset.section}`);
      //   if (source && destination) {
      //     destination.innerHTML = source.innerHTML;
      //     destination.classList.toggle('hidden', shouldHide(source));
      //   }
      // };

      // this.updateSourceFromDestination('.product-price');
      // updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
      // updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
      // updateSourceFromDestination('Volume');
      // updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

      // this.updateQuantityRules(this.sectionId, html);
      // this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
      // this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

      // this.productForm?.toggleSubmitButton(
      //   html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
      //   window.variantStrings.soldOut
      // );

      // publish(PUB_SUB_EVENTS.variantChange, {
      //   data: {
      //     sectionId: this.sectionId,
      //     html,
      //     variant,
      //   },
      // });
    };
  }
  getSelectedVariant(productInfoNode) {
    const selectedVariant = productInfoNode.querySelector(
      "variant-selector [data-selected-variant]"
    )?.innerHTML;
    return !!selectedVariant ? JSON.parse(selectedVariant) : null;
  }
  updateURL(url, variantId) {
    if (this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${url}${variantId ? `?variant=${variantId}` : ""}`
    );
  }
  updateOptionValues(html) {
    document.querySelectorAll('.product-options-selectbox .option-value').forEach(x => x.classList.remove('selected'))
    const optionsSelected = html.querySelectorAll(".product-options-selectbox .option-value.selected");
    optionsSelected.forEach(value => {
      let id = value.dataset.id;
      document.querySelector('.product-options-selectbox .option-value[data-id="' + id + '"]').classList.add('selected')
    })
  }
  updateSourceFromDestination(selector, html) {
    if (html.querySelector(selector)) {
      this.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    }
  }
  swiperMedia() {
    var thumbsSwiper = new Swiper(this.querySelector(".product__thumbs"), {
      slidesPerView: "auto",
      spaceBetween: 4,
      loop: false
    });
    this.mediaSwiper = new Swiper(this.querySelector(".product__media"), {
      slidesPerView: "auto",
      thumbs: {
        swiper: thumbsSwiper,
      },
    });
  }
  updateMedia() {
    if (!this.variantSelected?.featured_media?.id) return;
    const media = this.querySelector(
      '.product__media [data-media-id="' +
      this.variantSelected.featured_media.id +
      '"]'
    );
    const index = media.dataset.index;
    this.mediaSwiper.slideTo(index);
  }
  updateVariantInputs(valuesId) {
    if (valuesId) {
      this.querySelector(".product-variant-id").value = valuesId;
    } else {
      this.querySelector(".product-variant-id").value = "";
    }
  }
  updateQuantity(e) {
    var target = e.currentTarget;
    var quantity = parseInt(this.qtySelector.innerHTML);
    if (target.classList.contains("qty-plus")) {
      quantity += 1;
    } else {
      quantity = quantity == 1 ? 1 : quantity - 1;
    }
    this.qtySelector.innerHTML = quantity;
    this.querySelector(".product-quantity").value = quantity;
  }
  formSubmit(e) {
    e.preventDefault();
    this.atcBtn.setAttribute('disabled', true)
    this.atcBtn.classList.add('loading');
    this.cartBarBtn.setAttribute('disabled', true)
    this.cartBarBtn.classList.add('loading');
    this.atcBtn.querySelector('.add-to-cart-btn__text').innerHTML = 'Adding...'
    this.cartBarBtn.innerHTML = 'Adding...'
    var formData = new FormData(e.target);
    let data = {
      items: [
        {
          id: formData.get("id"),
          quantity: formData.get("quantity"),
        },
      ],
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then(res => {
        this.atcBtn.removeAttribute('disabled')
        this.atcBtn.classList.remove('loading');
        this.cartBarBtn.removeAttribute('disabled')
        this.cartBarBtn.classList.remove('loading');
        this.atcBtn.querySelector('.add-to-cart-btn__text').innerHTML = 'Add to cart'
        this.cartBarBtn.innerHTML = 'Add to cart'
        // window.location.href = '/cart'
        document.dispatchEvent(new CustomEvent('update:cart', {
          detail: false
        }))
      })
      .catch((error) => {
        this.atcBtn.removeAttribute('disabled')
        this.atcBtn.classList.remove('loading');
        this.atcBtn.querySelector('.add-to-cart-btn__text').innerHTML = 'Add to cart'
        console.error("Error:", error);
      });
  }
}
customElements.define("product-info", ProductInfo);